// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__L94u3","content":"styles_content__92ibi","linkWrapper":"styles_linkWrapper__QNCap","icon":"styles_icon__FrF80","image":"styles_image__TP08C"};